/**
 * @file The closed list of Orders lifecycle statuses a line table filter may
 * name, in tile order. Consumers: `analyticsView`, which drops any other
 * `status` value, and the Orders totals and line models. Each key is also the
 * `parameters/analytics` `lineItems` status list that defines it, so a
 * lifecycle filter keeps the lines whose status is in that list.
 */
export const ANALYTICS_ORDER_LIFECYCLES = [
  'held',
  'released',
  'shipped',
] as const;
